<template>
	<v-layout class="container column">
		<div class="third-route-title">{{ getStateWithParam("settings_label") }}</div>
		<LanguageSettings />
		<BaseAccordionCard :accordion_header="getStateWithParam('notification_label')">
			<template v-slot:component>
				<NotifycationSettings
					:key="notification_settings_key"
					:events_selection="incoming_settings.events"
					:street_notification="incoming_settings.streets"
					v-on:changeNotification="changeNotificationStatus"
					v-on:savedStreet="getSelectedStreets"
				/>
			</template>
		</BaseAccordionCard>
		<BaseAccordionCard :accordion_header="getStateWithParam('notify_me_only')">
			<template v-slot:component>
				<NotifyMeSettings
					:key="notify_me_settings_key"
					:digest="settings_form.digest"
					v-on:selected_days="getSelectedDays"
					v-on:notifyAnytimeEvent="notifyMeAnytime"
					v-on:startTime="getStartTime"
					v-on:endTime="getEndTime"
				/>
			</template>
		</BaseAccordionCard>
	</v-layout>
</template>

<script>
import settings from "@/config/api/api_events/settings.js";
import native_capacitor from "@/config/js_helper/native_capacitor.js";
import LanguageSettings from "@/components/cards/LanguageSettings";
import NotifycationSettings from "@/components/cards/NotifycationSettings";
import NotifyMeSettings from "@/components/cards/NotifyMeSettings";
import md5_user_id from "@/config/js_helper/md5_user_id.js";

export default {
	name: "Settings",
	components: {
		LanguageSettings,
		NotifyMeSettings,
		NotifycationSettings
	},
	data() {
		return {
			notification_settings_key: 100,
			notify_me_settings_key: 200,
			user_id: "",
			settings_form: {
				language: this.$store.state.type_language,
				found: 0,
				notific_activate: 0,
				notify: 0,
				digest: {
				anytime: 0,
				weekdays: ["0,0,0,0,0,0,0"],
				start: "",
				finish: ""
				},
				streetsAll: false,
				streets:
				"81,82,23,25,47,90,85,62,78,6083,84,28,29,88,22,24,94,27,93,14,12,46,15,95,91,41,92,40,26,24,94,76,75,10,9,33,35,34,32,21,20,2,1,3,36,37,87,86,67,66,48,64,71,65,49,74,73,101,102,89,44,43,45,42,11",
				events: []
			},
			incoming_settings: {},
			settingsunwatch: null
		};
	},
	watch: {
		settings_form: {
			handler: function(){
				//this.postSettingsUser();
			},
			deep: true
		}
	},
	mounted() {
		this.getSettingFromCall();
	},
	destroyed() {
		//this.postSettingsUser();
		if (this.settingsunwatch) {
			this.settingsunwatch()
		}
	},
  	methods: {
		changeNotificationStatus(event) {
			this.settings_form.events = event;
		},
		getSelectedStreets(streets) {
			this.settings_form.streets = streets;
		},
		getStartTime(startTime) {
			this.settings_form.digest.start = startTime;
		},
		getEndTime(endTime) {
			this.settings_form.digest.finish = endTime;
		},
		getSelectedDays(days) {
			if (days == "all") {
				this.settings_form.digest.weekdays = [1, 1, 1, 1, 1, 1, 1];
			} else {
				this.settings_form.digest.weekdays = days;
			}
		},
		notifyMeAnytime(notify) {
			this.settings_form.digest.anytime = notify;
		},
		getLangTypeToUse(lang_type = null) {
			if (lang_type == null) {
				return this.$store.state.type_language;
			} else {
				this.$store.commit('setNewLanguageType', parseInt(lang_type))
			}
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getSettingFromCall() {
			native_capacitor
			.getPhoneId()
			.then(el => {
				//this.user_id = CryptoJS.MD5(el.uuid);
				this.user_id = md5_user_id.getUserMd5Id(el.uuid);
				//this.user_id = el.uuid;
				settings
				.getSettings(this.user_id, this.$store.state.type_language)
				.then(response => {
					if (response.found) {
						this.fillSettingFormDataFromResponse(response);
					}
					this.$store.state.active_loader = false;

					this.notification_settings_key += 1;
					this.notify_me_settings_key += 1;
				})
				.then(() => {
					this.settingsunwatch = this.$watch('settings_form', function(){
						this.postSettingsUser()
					}, {deep: true})
				})
				.catch(error => {
					this.$store.state.active_loader = false;
					console.log("There was an error:", error);
				});
			})
			.catch(() => {});
		},
		fillSettingFormDataFromResponse(response) {
			this.settings_form.events = response.events;
			this.settings_form.digest = response.digest;
			this.settings_form.found = response.found;
			this.settings_form.notific_activate = response.notific_activate;
			this.settings_form.notify = response.notify;
			this.settings_form.streetsAll = response.streetsAll;
			this.settings_form.streets = response.streets;

			/* if (response.language != "") {
				this.settings_form.language = response.language;
				this.getLangTypeToUse(response.language);
			} else {
				this.settings_form.language = this.getLangTypeToUse();
			} */
			this.incoming_settings = response;
		},
		postSettingsUser() {
			this.settings_form.language = this.$store.state.type_language;
			let postdata = {...this.settings_form}
			postdata.user_id = this.user_id.toString()
			settings
			.postSettings(postdata)
			.catch(error => {
				console.log("There was an error:", error);
			});
		}
  	},
};
</script>

 <style scoped lang="scss" src="./Setting.scss">
</style>
